import toast from 'react-hot-toast';
import Icon from "@material-tailwind/react/Icon";
import Swal from "sweetalert2";
import Select from "react-select";
import { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { checkUser } from "helpers/Session";
import API, { getApiErrorMessage } from "../helpers/api";

const BestStaff = () => {
  const [bestStaff, setBestStaff] = useState([]);
  const [dummy, setDummy] = useState([]);
  const [message, setMessage] = useState("");
  const [id, setId] = useState(0);
  const [staff, setStaff] = useState("");
  const [kementerian, setKementerian] = useState(0);
  const [allKementerian, setAllKementerian] = useState([]);
  const [staffByKementerian, setStaffByKementerian] = useState([]);
  const [fase, setFase] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingForm, setLoadingForm] = useState(false);
  const [valid, setValid] = useState(false);
  const [loadingStaf, setLoadingStaf] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const phases = [
    { value: 1, label: "Phase 1" },
    { value: 2, label: "Phase 2" },
    { value: 3, label: "Phase 3" },
  ];
  const getPhaseLabel = (phase) =>
    phases.find((item) => item.value === Number(phase))?.label || "-";

  const addBestStaff = async () => {
    if (loadingForm) return;
    setLoadingForm(true);
    try {
      const res = await API.post("/bestStaff", {
        nim: staff.nim,
        id_kementerian: kementerian,
        phase: fase,
      });
      if (res.status === 200) {
        Swal.fire("Berhasil", res.data.message, "success");
        setLoadingForm(false);
        setShowAddModal(false);
        setLoading(true);
      }
    } catch (error) {
      Swal.fire("Gagal", getApiErrorMessage(error, "Data gagal ditambahkan"), "error");
    } finally {
      setLoadingForm(false);
    }
  };

  const editBestStaff = async () => {
    if (loadingForm) return;
    setLoadingForm(true);
    try {
      const res = await API.put(`/bestStaff/${id}`, {
        nim: staff.nim,
        id_kementerian: kementerian,
        phase: fase,
      });
      if (res.status === 200) {
        Swal.fire("Berhasil", "Data berhasil diubah!", "success");
      } else {
        toast.error("Gagal mengubah data!");
      }
    } catch (error) {
      
    } finally {
      setLoadingForm(false);
      setShowEditModal(false);
      setLoading(true);
    }
  };

  const deleteBestStaff = (id) => {
    Swal.fire({
      title: "Apakah kamu yakin?",
      text: "Kamu akan menghapus data tersebut?",
      icon: "warning",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return API.delete(`/bestStaff/${id}`)
          .then((response) => {
            if (response.status === 200) {
              return response.data;
            } else {
              throw new Error(response.data);
            }
          })
          .catch((error) => {
            toast.error("Data gagal dihapus");
            throw error; // Propagate the error further
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    })
      .then((res) => {
        if (res.isConfirmed) {
          toast.success("Data berhasil dihapus");
          setLoading(true);
        }
      })
      .catch((error) => {
        Swal.fire("Error", "Terjadi kesalahan: " + error.message, "error");
      });
  };

  useEffect(() => {
    if (!loading) return;
    API.get("/bestStaff")
      .then((res) => {
        const bestStaffData = Array.isArray(res.data.data) ? res.data.data : [];
        setBestStaff(bestStaffData);
        setDummy(bestStaffData);
      })
      .catch((err) => {
        Swal.fire("Error", err.message, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [loading]);

  useEffect(() => {
    let pass = true;
    if (staff === "") pass = false;
    if (kementerian === 0) pass = false;
    if (Number(fase) === 0) pass = false;
    if (pass) {
      setValid(true);
      setMessage("✅ Periksa kembali sebelum submit!");
    } else {
      setValid(false);
      setMessage("❌ Periksa format pengisian!");
    }
  }, [staff, kementerian, fase]);

  useEffect(() => {
    const fetchAllKementerian = async () => {
      const res = await API.get("/kementerian");
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      const dataAllKementerian = data.slice(0);
      setAllKementerian(dataAllKementerian);
    };
    fetchAllKementerian();
  }, []);

  const resetForm = () => {
    setStaff("");
    setKementerian(0);
    setFase(0);
    setLoadingForm(false);
    setLoadingStaf(false);
    setId(0);
  };

  const closeModal = () => {
    setShowAddModal(false);
    setShowEditModal(false);
    resetForm();
  };
  useEffect(() => {
    if (!showAddModal && !showEditModal) {
      resetForm();
    }
  }, [showAddModal, showEditModal]);

  useEffect(() => {
    const fetchStaffByKementerian = async () => {
      if (kementerian === 0) return;
      setLoadingStaf(true);
      try {
        const res = await API.get(
          "users/kementerian/" + kementerian + "/jabatan/1"
        );
        const res2 = await API.get(
          "users/kementerian/" + kementerian + "/jabatan/2"
        );
        const combinedData = [
          ...(Array.isArray(res.data.data) ? res.data.data : []),
          ...(Array.isArray(res2.data.data) ? res2.data.data : []),
        ];
        setStaffByKementerian(combinedData);
      } catch (error) {
        
      } finally {
        setLoadingStaf(false);
      }
    };
    fetchStaffByKementerian();
  }, [kementerian]);

  const setDataUpdate = (item) => {
    setId(item.id);
    setKementerian(item.id_kementerian);
    setStaff({
      nim: item.nim,
      nama: item.staff?.nama || "-",
    });
    setFase(item.phase);
    setShowEditModal(true);
  };

  const search = (keyword) => {
    if (keyword === "") {
      setBestStaff(dummy);
      return;
    }
    let result = dummy.filter(
      (item) =>
        (item.staff?.nama || "").toLowerCase().includes(keyword.toLowerCase()) ||
        (item.staff?.kementerian?.singkatan || "")
          .toLowerCase()
          .includes(keyword.toLowerCase()) ||
        getPhaseLabel(item.phase).toLowerCase().includes(keyword.toLowerCase())
    );
    setBestStaff(result);
  };

  return (
    <>
      {!checkUser() ? (
        <Redirect to={"/"} />
      ) : (
        <>
          <div className="bg-primary-light px-3 md:px-8 h-40" />

          <div className="px-3 md:px-8 h-auto -mt-36">
            <div className="container mx-auto max-w-full min-h-screen">
              <div className="grid grid-cols-1 px-4 mb-16">
                <div className="flex w-full justify-between my-4">
                  <div className="self-center">
                    <button className="bg-success text-white px-4 py-2 rounded-xl flex items-center gap-2 hover:bg-success/90 transition shadow-sm"
                      onClick={(e) => setShowAddModal(true)}
                    >
                      <Icon name="add" size="xl" /> Tambah Best Staff
                    </button>
                  </div>
                  <div className="self-center">
                    <div className="pt-2 relative mx-auto text-text-body">
                      <input
                        className="bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none"
                        type="text"
                        name="search"
                        placeholder="Cari Sesuatu..."
                        onChange={(e) => {
                          search(e.target.value);
                        }}
                      />
                      <button
                        type="submit"
                        className="absolute right-0 top-0 mt-5 mr-4"
                        disabled
                      >
                        <Icon name="search" size="xl" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="glass-card flex flex-col min-w-0 break-words bg-white w-full shadow-soft rounded-2xl">
                  <div className="p-6">
                    <div className="overflow-x-auto overflow-y-auto max-h-screen">
                      <table className="relative items-center w-full border-collapse">
                        <thead>
                          <tr>
                            <th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
                              No
                            </th>
                            <th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
                              Nama
                            </th>
                            <th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
                              Kementerian
                            </th>
                            <th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
                              Phase
                            </th>
                            <th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-center">
                              Aksi
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loading ? (
                            bestStaff.length > 0 ? (
                              bestStaff.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
                                      {index + 1}
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left capitalize">
                                      {(item.staff?.nama || "-").toLowerCase()}
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
                                      {item.staff?.kementerian?.singkatan || "-"}
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
                                      {getPhaseLabel(item.phase)}
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
                                      <div className="flex justify-evenly">
                                        <button className="bg-warning/10 text-warning p-2 rounded-lg hover:bg-warning hover:text-white transition shadow-sm group"
                                          onClick={(e) => {
                                            setDataUpdate(item);
                                          }}
                                        >
                                          <Icon name="edit" size="xl" />
                                        </button>
                                        <button className="bg-danger/10 text-danger p-2 rounded-lg hover:bg-danger hover:text-white transition shadow-sm group"
                                          onClick={(e) => {
                                            deleteBestStaff(item.id);
                                          }}
                                        >
                                          <Icon name="delete" size="xl" />
                                        </button>
                                      </div>
                                    </th>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  colSpan={5}
                                  className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-center"
                                >
                                  Tidak Ada Data
                                </td>
                              </tr>
                            )
                          ) : (
                            <tr>
                              <td
                                colSpan={5}
                                className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-center animate-pulse"
                              >
                                Memuat Data...
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showAddModal && (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none bg-text-heading/50 backdrop-blur-sm transition-all">
      <div className="relative w-full max-w-lg mx-auto my-6">
        <div className="border-0 rounded-2xl shadow-xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t-2xl">
            <h3 className="text-xl font-bold text-text-heading">
              Tambah Best Staff</h3>
            <button className="p-1 ml-auto bg-transparent border-0 text-text-muted float-right text-3xl leading-none font-semibold outline-none focus:outline-none hover:text-danger" onClick={() => closeModal()}>×</button>
          </div>
          <div className="relative p-6 flex-auto">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  addBestStaff();
                }}
              >
                <div className="flex flex-wrap">
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Kementerian
                    </label>
                    <select
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      onChange={(e) => {
                        setKementerian(e.target.value);
                        setStaffByKementerian([]);
                        setStaff("");
                      }}
                      value={kementerian}
                      required
                    >
                      <option value={0}>Pilih Kementerian</option>
                      {allKementerian ? (
                        allKementerian.map((item, index) => {
                          return (
                            <option key={index} value={item.id_kementerian}>
                              {item.singkatan}
                            </option>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </select>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nama
                    </label>
                    <Select menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      name="staff"
                      options={staffByKementerian}
                      getOptionLabel={(option) => option.nama}
                      getOptionValue={(option) => option.nim}
                      value={staff}
                      onChange={setStaff}
                      isDisabled={loadingStaf}
                      isLoading={loadingStaf}
                      placeholder="Pilih Staff..."
                      required
                    />
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Phase
                    </label>
                    <select
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      onChange={(e) => setFase(Number(e.target.value))}
                      value={fase}
                      required
                    >
                      <option value={0}>Pilih Phase</option>
                      {phases.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="w-full flex justify-between items-center">
                    <button
                      type="submit"
                      className="text-white bg-primary focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:opacity-30 disabled:pointer-events-none"
                      disabled={loadingForm || !valid}
                    >
                      Submit
                    </button>
                    <p className="text-sm text-gray-700">{message}</p>
                  </div>
                </div>
              </form>
            </div>
        </div>
      </div>
    </div>
  )}

          {showEditModal && (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none bg-text-heading/50 backdrop-blur-sm transition-all">
      <div className="relative w-full max-w-lg mx-auto my-6">
        <div className="border-0 rounded-2xl shadow-xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t-2xl">
            <h3 className="text-xl font-bold text-text-heading">
              Ubah Best Staff</h3>
            <button className="p-1 ml-auto bg-transparent border-0 text-text-muted float-right text-3xl leading-none font-semibold outline-none focus:outline-none hover:text-danger" onClick={() => closeModal()}>×</button>
          </div>
          <div className="relative p-6 flex-auto">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  editBestStaff();
                }}
              >
                <div className="flex flex-wrap">
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Kementerian
                    </label>
                    <select
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      onChange={(e) => {
                        setKementerian(e.target.value);
                        setStaffByKementerian([]);
                        setStaff("");
                      }}
                      value={kementerian}
                      required
                    >
                      <option value={0}>Pilih Kementerian</option>
                      {allKementerian ? (
                        allKementerian.map((item, index) => {
                          return (
                            <option key={index} value={item.id_kementerian}>
                              {item.singkatan}
                            </option>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </select>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nama
                    </label>
                    <Select menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      name="staff"
                      options={staffByKementerian}
                      getOptionLabel={(option) => option.nama}
                      getOptionValue={(option) => option.nim}
                      value={staff}
                      onChange={setStaff}
                      isDisabled={loadingStaf}
                      isLoading={loadingStaf}
                      placeholder="Pilih Staff..."
                      required
                    />
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Phase
                    </label>
                    <select
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      onChange={(e) => setFase(Number(e.target.value))}
                      value={fase}
                      required
                    >
                      <option value={0}>Pilih Phase</option>
                      {phases.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="w-full flex justify-between items-center">
                    <button
                      type="submit"
                      className="text-white bg-primary focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:opacity-30 disabled:pointer-events-none"
                      disabled={loadingForm || !valid}
                    >
                      Submit
                    </button>
                    <p className="text-sm text-gray-700">{message}</p>
                  </div>
                </div>
              </form>
            </div>
        </div>
      </div>
    </div>
  )}
        </>
      )}
    </>
  );
};

export default BestStaff;
